import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=f20761e4&scoped=true&"
import script from "./RoleDetail.vue?vue&type=script&lang=js&"
export * from "./RoleDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetail.vue?vue&type=style&index=0&id=f20761e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20761e4",
  null
  
)

export default component.exports